import styled, { css } from 'styled-components'

export const StepperContainer = styled.div`
  width: 100%;
  max-width: 750px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  span {
    color: #C8C8C8;
    font-weight: 800;
    font-size: 14px;
    line-height: 21px;
    white-space: nowrap;

    display: flex;
    align-items: center;

    svg {
      height: 20px;
      width: 20px;
      margin-right: 6px;
      color: #3D6666;
      stroke-width: 10;
    }
  }

  .progressbar-name-highlighted {
    color: #3D6666;
  }

  @media only screen and (max-width: 1190px) {
    display: none;
  }
`

export const StepperProgressBar = styled.div<{ width: number, willDisplay?: boolean, height?: string }>`
  width: 100%;
  max-width: 40px;
  height: ${props => props.height ?? '2px'};
  background: #C8C8C8;

  div {
    width: ${props => props.width}%;
    height: 100%;
    background: #3D6666;
  }

  ${props => !props.willDisplay && css`
    &:last-of-type {
      display: none;
    }
  `}
`